import { http } from '@/api/http'

export function getPositions() {
    return http.get('positions/').then(r => r.data.results || r.data)
}

export function getRanks() {
    return http.get('ranks/').then(r => r.data.results || r.data)
}

export function createRank(payload) {
    return http.post('ranks/', payload).then(r => r.data)
}
export function updateRank(id, payload) {
    return http.patch(`ranks/${id}/`, payload).then(r => r.data)
}
export function deleteRank(id) {
    return http.delete(`ranks/${id}/`).then(r => r.data)
}

export function createPosition(payload) {
    return http.post('positions/', payload).then(r => r.data)
}
export function updatePosition(id, payload) {
    return http.patch(`positions/${id}/`, payload).then(r => r.data)
}
export function deletePosition(id) {
    return http.delete(`positions/${id}/`).then(r => r.data)
}

export function getUserCategories() {
    return http.get('user-categories/').then(r => r.data)
}

export function createUser(payload) {
    return http.post('users/', payload).then(r => r.data)
}

export function updateUser(id, payload) {
    return http.patch(`users/${id}/`, payload).then(r => r.data)
}

export function linkUserToChpo(payload) {
    // payload: { chpo_id, user_id }
    return http.post('chpo/chpo-user/', payload).then(r => r.data)
}

export function linkUserToBook(payload) {
    // payload: { book_id, user_id }
    return http.post('book/users/', payload).then(r => r.data)
}

// Для удаления связи с CHPO (архивация)
export function archiveChpoUser(linkId) {
    return http.patch(`chpo/chpo-user/${linkId}/`, { is_archived: true }).then(r => r.data)
}

// Для удаления связи с Book (если потребуется, пока предположим удаление через users endpoint или аналогично)
// В Postman нет явного "archive book user", но возможно это делается через удаление user из book
// Или просто удаление самого user, если он создан только для этого?
// Пока оставим placeholder или будем использовать updateUser с каким-то флагом, если узнаем.
// Но пользователь сказал "удаление как и во всех DataTable", обычно это DELETE запрос.
// Посмотрим, есть ли DELETE для book/users/{id}? В Postman не было.
// Пока добавим функцию удаления самого юзера, если это то, что нужно.
// Soft delete (archive)
export function archiveUser(id) {
    return http.patch(`users/${id}/`, { is_archived: true }).then(r => r.data)
}

// Hard delete
export function deleteUser(id) {
    return http.delete(`users/${id}/`).then(r => r.data)
}
